<template>
  <div class="intro">
    <div class="container height-100 container-offset-right">
      <div class="logo">
        <h3>
          <a href="/">
            <span class="smaller">{</span> sheehanweb
            <span class="smaller">}</span>
          </a>
        </h3>
      </div>
      <div class="ghost-table margin-minus-logo center">
        <div class="ghost-center">
          <div class="profile">
            <img src="../img/profile-2024.jpg" alt="Joe Sheehan Profile Picture" />
          </div>
          <h1>Joe Sheehan</h1>
          <p class="max-800">
            With 14 years of experience as a Web/App Developer, I possess a versatile skill set covering front-end and back-end technologies. I excel in designing and developing web applications, utilizing a deep understanding of programming languages and frameworks to deliver scalable solutions. Experienced in leading projects and collaborating with cross-functional teams, I stay updated with industry trends to deliver cutting-edge solutions.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hello World',
  props: {
    msg: String
  }
}
</script>
